import React from "react";

const TendersForm = () => {
  return (
    <div className="pb-5 ">
      <div className="container">
        <div className="bg-white p-md-5 p-4 rounded-4">
          <h4 className=" fs_26 fw-bold ff_inter color_blue">
            Drone Tender Enquiry
          </h4>
          <div className="row">
            <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
              <label
                className=" fs_16 ff_inter fw-medium color_darkgray"
                htmlFor="name"
              >
                First Name*
              </label>
              <input
                className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                type="text"
                id="name"
              />
            </div>
            <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
              <label
                className=" fs_16 ff_inter fw-medium color_darkgray"
                htmlFor="name"
              >
                Last Name*
              </label>
              <input
                className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                type="text"
                id="name"
              />
            </div>{" "}
            <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
              <label
                className=" fs_16 ff_inter fw-medium color_darkgray"
                htmlFor="name"
              >
                Email*
              </label>
              <input
                className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                type="text"
                id="name"
              />
            </div>
            <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
              <label
                className=" fs_16 ff_inter fw-medium color_darkgray"
                htmlFor="name"
              >
                Phone Number*
              </label>
              <input
                className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                type="text"
                id="name"
              />
            </div>
            <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
              <label
                className=" fs_16 ff_inter fw-medium color_darkgray"
                htmlFor="name"
              >
                Company/Organization
              </label>
              <input
                className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                type="text"
                id="name"
              />
            </div>
            <div className="col-sm-6 mt-lg-4 mt-3 d-flex flex-column">
              <label
                className=" fs_16 ff_inter fw-medium color_darkgray"
                htmlFor="name"
              >
                Project Title
              </label>
              <input
                className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
                type="text"
                id="name"
              />
            </div>
          </div>
          <div className="w-100 mt-lg-4 mt-3 d-flex flex-column">
            <label
              className=" fs_16 ff_inter fw-medium color_darkgray"
              htmlFor="name"
            >
              Describe the issue being faced
            </label>
            <textarea
              className="custom_input w-100 rounded-2 py-2 px-3 mt-2"
              name="Message"
              id="Message"
              placeholder="Type Here"
              rows={7}
            ></textarea>
          </div>

          <button className=" bg_darkblue1 border-0 rounded-2 fs_20 mt-4 fw-semibold text-white px-4 py-2">
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default TendersForm;
